import React from 'react';
import { useHomeRedesignStrings } from './useHomeRedesignStrings';

const HomeRedesignLessAlone: React.FC = () => {
  const s = useHomeRedesignStrings();

  return (
    <section className="container-chisme py-8 lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:gap-x-16 lg:gap-y-10 lg:py-16">
      <div className="mb-10 max-w-md lg:mb-0 lg:max-w-lg">
        <h2 className="font-instrument text-[2.4rem] leading-none tracking-[-0.02em] text-[#2a0f2a] sm:text-5xl lg:text-[88px] lg:leading-[0.95] lg:tracking-[-0.025em]">
          <span className="block">{s.lessAlone.h2a}</span>
          <span className="block italic text-chisme-primary">{s.lessAlone.h2b}</span>
        </h2>
        <p className="mt-4 font-jakarta text-base leading-relaxed text-[#5a3158] lg:mt-5 lg:max-w-[420px] lg:text-[17px] lg:leading-[25.5px]">
          {s.lessAlone.bodyBefore}
          <span className="font-instrument text-lg italic lg:text-xl">{s.lessAlone.bodyShowUp}</span>
          {s.lessAlone.bodyAfter}
        </p>
      </div>

      <div className="min-w-0">
        {s.lessAlone.rows.map((row) => (
          <div
            key={row.left}
            className="flex flex-col gap-1 border-t border-[rgba(74,33,71,0.1)] py-5 sm:flex-row sm:items-center sm:justify-between sm:gap-4 sm:py-6 lg:py-[26px]"
          >
            <p className="font-jakarta text-base text-[#5a3158] sm:text-lg lg:text-[22px] lg:tracking-[-0.01em]">
              {row.left}
            </p>
            <p className="shrink-0 font-instrument text-lg italic tracking-[-0.01em] text-[#2a0f2a] sm:text-right sm:text-xl lg:text-[30px]">
              {row.right}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeRedesignLessAlone;
